@if (time) {
  <span class="timer badge badge-lg">
    <p class="m-0">
      @if (dutch) {
        Nog&nbsp;
      }
      <span class="mono">
        {{ expired || time <= 0 ? '00:00' : (time | date: 'mm:ss') }}
      </span>
      <span class="timer__long">{{ 'timer.left_to_complete' | transloco }}</span>
      <!-- Dutch reads "Nog 10:34" on its own; English needs the "left". -->
      @if (!dutch) {
        <span class="timer__short">{{ 'timer.left' | transloco }}</span>
      }
    </p>
  </span>
}
